<input
    matInput
    #inputElement
    qa="currency-input-element"
    autocomplete="off"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [disabled]="disabled"
    [required]="required"
    [value]="getFormattedValue()"
    (input)="onInput($event)"
    (change)="onChange($event)"
    (blur)="onBlur($event)"
    (focus)="onFocus($event)"
/>
